import {
    addToChainAfter,
    Handler,
    HasOnError,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import {
    GetAlsoPurchasedProductCollectionApiV2Parameter,
    GetProductCollectionApiV2Parameter,
    GetRelatedProductCollectionApiV2Parameter,
} from "@insite/client-framework/Services/ProductServiceV2";
import {
    chain,
    PopulateApiParameter,
    RequestDataFromApi,
} from "@insite/client-framework/Store/Data/Products/Handlers/LoadProducts";
import { ProductCollectionModel, ProductModel } from "@insite/client-framework/Types/ApiModels";
import { getProductsDataView } from "@insite/client-framework/Store/Data/Products/ProductsSelectors";

type Parameter = (
    | GetProductCollectionApiV2Parameter
    | GetRelatedProductCollectionApiV2Parameter
    | GetAlsoPurchasedProductCollectionApiV2Parameter
) &
    HasOnSuccess<ProductModel[]> &
    HasOnError<string>;
type Props = {
    apiParameter:
        | GetProductCollectionApiV2Parameter
        | GetRelatedProductCollectionApiV2Parameter
        | GetAlsoPurchasedProductCollectionApiV2Parameter;
    apiResult: ProductCollectionModel;
};

type HandlerType = Handler<Parameter, Props>;

export const PopulateApiParameterExtension: HandlerType = props => {
    const { onSuccess, onError, isLoadMore, setPreSelectAttributes, ...parameter } = props.parameter as any;
    props.apiParameter = parameter;

    if (isLoadMore) {
        const prevApiParams: typeof props.apiParameter = { ...props.apiParameter };
        prevApiParams.page =
            props.apiParameter.page && props.apiParameter.page > 1 ? props.apiParameter.page - 1 : undefined;
        const prevProducts = getProductsDataView(props.getState(), prevApiParams).value;
        if (!prevProducts && props.parameter.page && props.parameter.page > 1) {
            props.apiParameter.page = 1;
            props.apiParameter.pageSize = props.parameter.pageSize! * props.parameter.page;
        }
    }
};

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterExtension);

export const SetPreSelectAttributes: HandlerType = ({ apiResult, getState, parameter }) => {
    if (!apiResult) {
        return;
    }

    if (apiResult.properties?.preSelectCategoryAttributes && (parameter as any).setPreSelectAttributes) {
        // const preSelectCategoryAttributes =
        //     "a67d71a0-dc70-468d-abec-aff100a817b7,f77d06fa-f424-4145-880b-aff100a7bf19,cfde471b-aae5-4f7d-bf95-aff100a7d87a";

        (parameter as any).setPreSelectAttributes?.(
            apiResult.properties?.preSelectCategoryAttributes.replace(/^"|"$/g, ""),
        );
    }
};

addToChainAfter(chain, RequestDataFromApi, SetPreSelectAttributes);
